import { render } from "./ViewCollection.vue?vue&type=template&id=8a5f73c2"
import script from "./ViewCollection.vue?vue&type=script&lang=js"
export * from "./ViewCollection.vue?vue&type=script&lang=js"
script.render = render

export default script